<template>
    <v-tab-item :key="tab_key" class="pb-2">
        <v-row>
            <v-col cols="8">
                <v-row class="ml-1 mr-1" v-if="alert">
                    <v-alert dense text type="success">
                        {{ alertMessage }}<strong>!</strong>
                        <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-row>
            </v-col>
            <v-col cols="4">
                <v-col class="col-md-12 col-sm-12">
                    <date-picker class="float-right" v-model="fechas" @change="cargarDatos"
                        range-separator="|" range placeholder ="Búsqueda por Fechas" 
                        format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD">
                    </date-picker>
                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                </v-col>
            </v-col>
        </v-row>
        <v-row class="ml-1 mr-1">
            <v-col class="col-md-3 col-sm-12">
                <!-- COMIENZO INGRESAR/MODIFICAR DATO -->
                <v-card class="mb-2 py-6">
                    <v-row class="ml-1 mr-1" v-for="campo in encabezado" :key="campo.value">
                        <template v-if="!campo.hide_create">
                            <v-col class="col-md-3 col-sm-6 py-3" v-if="campo.type === 'date'">
                                {{ `${campo.text}${campo.optional ? '' : '*'}` }}
                            </v-col>
                            <v-col :class="`${campo.type === 'date' ? 'col-md-9 col-sm-6' : ''} py-0`">
                                <date-picker 
                                    v-if="campo.type === 'date'"
                                    v-model="dato[campo.value]" 
                                    placeholder ="Seleccione Fecha *" 
                                    format="DD-MM-YYYY" 
                                    :default-value="dato[campo.value]" 
                                    valueType="YYYY-MM-DD"
                                ></date-picker>
                                <v-select
                                    v-else-if="campo.type === 'select'"
                                    :items="extra[campo.use]"
                                    item-text="nombre"
                                    item-value="id"
                                    v-model="dato[campo.value]"
                                    :label="campo.text + (campo.optional ? '' : ' *')"
                                ></v-select>
                                <v-text-field
                                    v-else 
                                    v-model="dato[campo.value]" 
                                    :label="campo.text + (campo.optional ? '' : ' *')" 
                                    :placeholder="campo.text + (campo.optional ? '' : ' *')" 
                                    :type="campo.type" 
                                ></v-text-field>
                            </v-col>
                        </template>
                    </v-row>
                    <v-row class="mx-1">
                        <v-col class="col-12 py-0 caption">
                            Para habilitar botón de registrar/modificar, debe rellenar todos los campos marcados como obligatorio (*).
                        </v-col>
                    </v-row>
                    <v-row class="mx-1">
                        <v-col class="text-center">
                            <v-btn class="green darken-1" :dark="true" @click="ingresarDato" :disabled="!campos_validos">{{ registro }}</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
                <!-- FIN INGRESAR/MODIFICAR DATO -->           
            </v-col>
            <v-col>
                <v-data-table :headers="encabezado" :items="datos" :item-class="rowClass" class="elevation-1">
                    <template v-slot:item.turnos_id="{ item }">
                        <span>{{ extra.turnos.find(turno => turno.id === item.turnos_id) && extra.turnos.find(turno => turno.id === item.turnos_id).nombre }}</span>
                    </template>
                    <template v-if="tab_key === 'rec_comb' || tab_key === 'cons_comb'" v-slot:item.tipo_combustibles_id="{ item }">
                        <span>{{ item.tipo_combustibles }}</span>
                    </template>
                    <template v-if="tab_key === 'cons_ener'" v-slot:item.tipo_energias_id="{ item }">
                        <span>{{ item.tipo_energias }}</span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div class="d-flex justify-space-around">
                            <v-icon color="blue darken-4" @click=seleccionarDato(item)>edit</v-icon>
                            <v-btn color="red darken-4" dark small icon @click="eliminarDato(item)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-tab-item>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'

export default {
    data() {
        return {
            alert: false,
            alertMessage: '',
            fechas: new Date().toISOString().substring(0, 10),
            datos: [],
            dato: { ...this.dato_default },
        }
    },
    props: {
        tab_key: String,
        nombre_dato: String,
        url_datos: String,
        url_actualizar: String,
        encabezado: Array,
        dato_default: Object,
        extra: Object,
    },
    mounted() {
        this.cargarDatos();
    },
    methods:{
        async cargarDatos(){
            let url = this.url_datos;
            if(typeof this.fechas === "object") {
                this.mostrarLoading({titulo:`Buscando datos entre ${this.fechas[0]} y ${this.fechas[1]}...`, color:'green'});
                url = url + `?fecha_ini=${this.fechas[0]}&fecha_fin=${this.fechas[1]}`
            } else {
                this.mostrarLoading({titulo:`Buscando datos...`, color:'green'});
            }

            await this.axios.get(url, this.headers).then((res)=>{
                console.log({res});
                this.datos = res.data.data.map(dato => {
                    return {
                        ...dato,
                        seleccionado: false,
                    }
                });
                this.ocultarLoading();
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar datos ");
            });
        },

        async ingresarDato(){
            this.mostrarLoading({ titulo: `Ingresando ${this.nombre_dato}`, color:'green' })

            const data = { ...this.dato }

            let url = this.url_actualizar;

            if(this.dato.id > 0){
                url = url + `/${this.dato.id}`;
            }
            await this.axios.post(url, data, this.headers).then((res)=>{
                console.log(`${this.nombre_dato} ${this.dato.id > 0 ? 'actualizado' : 'creado'}`, res.data.data);
                this.alertMessage = `${ this.nombre_dato } ${ this.dato.id ? "actualizado" : "registrado" } correctamente`;
                this.alert = true;
                this.ocultarLoading();
                this.cargarDatos();
                this.limpiarDato();
            }).catch((e)=>{
                this.errorMessage(e, `Error al ${this.dato.id > 0 ? 'actualizar' : 'crear'} ${this.nombre_dato}`);
            });
        },
        async eliminarDato(item){
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `¿Desea eliminar ${this.nombre_dato}?`,
                okButton: 'Eliminar',
            });
            if(ok) {
                this.mostrarLoading({ titulo: `Eliminando ${this.nombre_dato}`, color:'green' });
                const url = `${this.url_datos}/${item.id}`;
                await this.axios.delete(url,this.headers).then((res)=>{
                    console.log(`${this.nombre_dato} eliminado correctamente`);
                    this.alertMessage = `${ this.nombre_dato } eliminado correctamente`;
                    this.alert = true;
                    this.ocultarLoading();
                    this.cargarDatos();
                }).catch((e)=>{
                    this.errorMessage(e, `Error al eliminar ${this.nombre_dato}`);
                });
            }
        },
        rowClass (item) {
            return item.seleccionado ? "row-seleccionada" : "";
        },
        seleccionarDato(item) {
            if(this.alert) this.alert = false;
            
            this.datos = this.datos.map(dato => {
                if(dato.id === item.id) {
                    if(!dato.seleccionado) {
                        dato.seleccionado = true;
                        this.dato = dato;
                    } else { 
                        dato.seleccionado = false;
                        this.limpiarDato();
                    };
                } else {
                    dato.seleccionado = false;
                }
                return dato; 
            });
        },
        limpiarDato() {
            this.dato = { ...this.dato_default }
        },

        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        registro() {
            return this.dato.id ? "Modificar" : "Registrar";
        },
        campos_validos() {
            const validos = Object.entries(this.dato).every(([key, value]) => {
                // Campos que no se validan / opcionales
                if(key === "id") return true;
                if(key === "users_id") return true;
                if(key === "turnos_id") return typeof value === "number" && value >= 0;
                
                const enc = this.encabezado.find(enc => enc.value === key); 
                if(enc && enc.optional) return true;
                
                if(enc && enc.type === "number") return parseInt(value) >= 0;

                return value
            });
            return validos;
        },
        ...mapState(['base_url', 'headers'])
    },
    components: {
        DatePicker,
        ConfirmDialogue,
    },
}
</script>

<style>
    
</style>